<template>
  <div
    :class="{'is-open' : !collapsed, 'mobile-clickable' : widgetSettings.linkListCollapsible && widgetSettings.linkHeadline }"
    class="link-list-container"
  >
    <div
      v-if="widgetSettings.linkHeadline"
      class="link-list-title"
      @click="collapse()"
    >
      <h3 :style="`color: ${linkHeadlineColor} `">{{ widgetSettings.linkHeadline }}</h3>
      <div
        v-if="widgetSettings.linkListCollapsible"
        class="link-list-title-icon"
      >
        <div
          :style="`color: ${widgetSettings.linkColor}`"
          class="icon-container"
        >
          <list-svg-icons
            name="ChevronDown"
            class="icon"
          />
        </div>
      </div>
    </div>

    <div
      :class="{ 'mobile-collapsed': collapsed && widgetSettings.linkHeadline }"
      class="link-list-navigation-container"
    >
      <b-nav
        vertical
        class="link-list"
      >
        <li
          v-for="(item, index) in linkItems"
          :key="index"
          class="link-list-item"
        >

          <generic-link
            :href="item.linkUrl"
            :title="item.linkTitle"
            :target="item.linkTarget"
            :style="`color: ${linkColor}`"
            class="link-list-item-link"
          >
            <span
              v-if="widgetSettings.linkIcon && widgetSettings.linkIconPosition === 'left'"
              :style="`color: ${linkIconColor}`"
              class="link-list-item-icon icon-left"
            >
              <div
                :style="`border-color: ${linkIconColor}`"
                class="icon-container"
              >
                <list-svg-icons
                    :name="widgetSettings.linkIcon"
                    class="icon"
                />
              </div>
            </span>

            <span class="link-list-item-text">
              {{ item.linkText }}
            </span>

            <span
              v-if="widgetSettings.linkIcon && widgetSettings.linkIconPosition === 'right'"
              :style="`color: ${linkIconColor}`"
              class="link-list-item-icon icon-right"
            >
              <div class="icon-container">
                <list-svg-icons
                    :name="widgetSettings.linkIcon"
                    class="icon float-right"
                />
              </div>
            </span>
          </generic-link>
        </li>
      </b-nav>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions'
import GenericLink from '../ui-elements/generic-link'
import ListSvgIcons from '../ui-elements/linklist-svg-icons'

export default {
  components: {
    CollapseTransition,
    GenericLink,
    ListSvgIcons
  },
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      collapsed: true
    }
  },
  computed: {
    widgetSettings: function() {
      return this.widget.widgetSettings
    },
    linkItems: function() {
      return this.widget.linkItems
    },
    linkColor: function() {
      return this.rgbaToString(this.widgetSettings.linkColor)
    },
    linkIconColor: function() {
      return this.rgbaToString(this.widgetSettings.linkIconColor)
    },
    linkHeadlineColor: function() {
      return this.rgbaToString(this.widgetSettings.linkHeadlineColor)
    },
    linkListCollapsible() {
      return this.widgetSettings.linkListCollapsible
    }
  },
  watch: {
    linkListCollapsible: {
      handler(val) {
        if (!val) {
          this.collapsed = false
        }
      },
      immediate: true
    }
  },
  methods: {
    rgbaToString: function(value) {
      if (typeof value === 'object' && value.rgba) {
        return `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`
      } else if (typeof value === 'string') {
        return value;
      }
      return '';
    },
    collapse: function() {
      if (this.linkListCollapsible) {
        this.collapsed = !this.collapsed
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

//define link list variable defaults here -----------------------------------------------------------------

//link list tile color, link list link color and link list icon color are handleded by the client via the content creator

//link list title
$link-list-title-size:1.4em !default;
$link-list-title-padding:.75em 0em !default;

//link list item
$link-list-item-size:1.1em !default;
$link-list-item-padding:.75em 0em !default;
$link-list-transition-time: .3s !default;

//link list borders

//if true a border around link-list container will be added, appropriate styling to deal with collapsed and non collapsed state is also included
$link-list-container:false !default;
//if true then
$link-list-container-border:$border-color !default;

//if the list items will be seperated by a border
$link-list-borders: false !default;

//if true then
$link-list-item-border-color: $border-color !default;
$link-list-item-border-style: solid !default;

//
$link-list-title-border-style: solid !default;

//link list item icon container styling

$link-list-item-icon-container: false !default;
$link-list-item-icon-border-style: solid !default;

// -------------------------------------------------------------------------------------------------------

//if link list container is set to true
//we styled the container around the link list and add approriate padding

@if $link-list-container  {
  .link-list-container {
    padding: .75em 1.5em;
    border: 2px solid;
    border-color: $border-color;
  }
  .link-list-item {
      border-top: 1px $link-list-item-border-style;
      border-color: $link-list-item-border-color;
  }

  } @else {
  .link-list-title {
    border-bottom:1px $link-list-item-border-style;
    border-color: $link-list-item-border-color;
  }
  //invert the link list item display

  .link-list-item {
      &:not(:last-child) {
      border-bottom: 1px $link-list-item-border-style;
      border-color: $link-list-item-border-color;
      }
  }
  }

//if link list borders are set to true
@if ($link-list-borders) {
}  @else {
  .link-list-container  {
  .link-list-title {
  @include media-breakpoint-up(md) {
  border:0px;
  }
  }
  .link-list-item {
    border:0px;
  }
}
}

@if ($link-list-item-icon-container) {
  .link-list-item {
    .icon-container {
      box-sizing: content-box;
      height: 1em;
      width: 1em;
      padding: .75em;
      font-size:.8em;
      text-align: center;
      line-height: inherit;
      position: relative;
      display: flex;
      border-radius: 100%;
      border:1px $link-list-item-icon-border-style;
    }
    .icon {
      margin: 0em auto;
    }
  }
}

//when collapsible, include transitions and collapse additions
.link-list-navigation-container {
  transition: ease-in-out all 0.3s;
  transform: scaleY(1);
  transform-origin: top;
  @include media-breakpoint-up(md) {
    height: auto;
    display: block !important;
  }
  &.mobile-collapsed {
    @include media-breakpoint-down(sm) {
      transform: scaleY(0);
      overflow: hidden;
      height: 0;
    }
  }
}

.link-list-container {
  height:100%;

    //when the widget is collapsible, adjust cursor appearnce on title to indicate this this is clickable on sm and down
    &.mobile-clickable {
      .link-list-title {
      @include media-breakpoint-down(sm) {
        cursor: pointer;
      }
    }
  }

  .link-list-title {
    .link-list-title-icon {
      margin-left: auto;
      .icon-container {
        margin-left: 1em;
        @include media-breakpoint-up(md) {
          display: none;
        }
      }
    }
    .icon {
      width:1em;
      height:1em;
      @include transition(transform 0.2s);
    }
  }
  &.is-open {
    .link-list-title {
      .icon {
        transform: rotate(180deg);
      }
    }
  }
}

.link-list-title {
  word-break: break-word;
  padding: $link-list-title-padding;
  display: flex;
  align-items: center;
}

.link-list {
  width: 100%;
}

.link-list-item {
  .link-list-item-text {
    //break all is an edge fallback
    word-break: break-all;
    word-break: break-word;
  }
  .link-list-item-link {
    font-size: $link-list-item-size;
    padding: $link-list-item-padding;
    display: flex;
    align-items: center;
    @include hover-focus {
      //when icon is right we nudge icon left on link hover/focus
      .link-list-item-icon {
        .icon-container {
          transform: translateX(.75em);
        }
      } //when icon is right we nudge icon left on link hover/focus
      .link-list-item-icon.icon-right {
        .icon-container {
          transform: translateX(-.75em);
        }
      }
    }
  } //double set padding to allow for the transition to complete before the content
  .link-list-item-icon {
    &.icon-left {
    margin-right:.5em;
    padding-right:.75em;
    }
     //slightly more padding added
    &.icon-right {
      padding-left: 1em;
      margin-left: auto;
      .icon-container {
      margin-left: .5em;
      }
    }
  }
  .icon-container {
    @include transition (transform .3s);
    transform: translate(0, 0em);
  }

 ::v-deep .icon {
    width: 1em;
    height: 1em;
  }
}
</style>
